import React, { useRef } from "react";
import DashboardLayout from "../../../layoutcontainers/DashboardLayout";
import html2canvas from "html2canvas";
import { jsPDF } from "jspdf";
import NewQuationPage from "./NewQuationPage";
import "./pdf.css";
 
const NewQuationPdf = () => {
  const pdfRef = useRef();
 
  const generatePDF = async () => {
    const input = pdfRef.current;
    const pdf = new jsPDF("p", "mm", "a4");
 
    const canvas = await html2canvas(input, { scale: 2 });
    const imgData = canvas.toDataURL("image/jpeg", 1.0);
 
    const imgWidth = 210;
    const pageHeight = 297;
    const imgHeight = (canvas.height * imgWidth) / canvas.width;
 
    let heightLeft = imgHeight;
    let position = 0;
 
    pdf.addImage(imgData, "JPEG", 0, position, imgWidth, imgHeight);
    heightLeft -= pageHeight;
 
    while (heightLeft > 0) {
      position -= pageHeight;
 
      if (heightLeft > 5) {
        pdf.addPage();
        pdf.addImage(imgData, "JPEG", 0, position, imgWidth, imgHeight);
      }
 
      heightLeft -= pageHeight;
    }
 
    pdf.save("quotation.pdf");
  };
 
 
  return (
    <DashboardLayout>
      <button onClick={() => generatePDF()} class="Download-button">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          height="16"
          width="20"
          viewBox="0 0 640 512"
        >
          <path
            d="M144 480C64.5 480 0 415.5 0 336c0-62.8 40.2-116.2 96.2-135.9c-.1-2.7-.2-5.4-.2-8.1c0-88.4 71.6-160 160-160c59.3 0 111 32.2 138.7 80.2C409.9 102 428.3 96 448 96c53 0 96 43 96 96c0 12.2-2.3 23.8-6.4 34.6C596 238.4 640 290.1 640 352c0 70.7-57.3 128-128 128H144zm79-167l80 80c9.4 9.4 24.6 9.4 33.9 0l80-80c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-39 39V184c0-13.3-10.7-24-24-24s-24 10.7-24 24V318.1l-39-39c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9z"
            fill="white"
          ></path>
        </svg>
        <span>Download Pdf</span>
      </button>
 
      <NewQuationPage pdfRef={pdfRef} />
    </DashboardLayout>
  );
};
 
export default NewQuationPdf;